export default __webpack_public_path__ + "static/media/arrowdown-new.79b3f79c.svg";